import { PricingTranslations } from "./types";

export const deTranslations: PricingTranslations = {
    bookDemoButtonText: "Demo buchen",
    section: {
        title: "Preispläne für alle",
        description: "Wählen Sie einen günstigen Plan mit den besten Funktionen - ob Sie Medizinstudent:in auf der Suche nach Verbesserung, Assistenzarzt/-ärztin in der Prüfungsvorbereitung oder eine medizinische Fakultät sind, die interaktive Werkzeuge in ihren Lehrplan aufnehmen möchte",
        toggleMonthly: "Monatlich",
        toggleYearly: "Jährlich",
        perMonth: " Benutzer / Monat",
        perYear: " Benutzer / Jahr",
    },
    plans: {
        basic: {
            title: "Basis",
            details: "Ein Plan, der Ihnen unbegrenzte Übungsfälle in Ihrem eigenen Tempo ermöglicht und das Lernen an Ihre individuellen Ziele anpasst",
            features: [
                "52 Krankheiten",
                "Basis-Analysen",
                "Chatbot-Patienten"
            ]
        },
        plus: {
            title: "Plus+",
            details: "Ein Plan, der Ihren Studierenden unbegrenzte Übungsfälle ermöglicht und Ihnen die Kontrolle über deren Lernfortschritt gibt",
            features: [
                "Alle die gleichen grundlegenden",
                "Erweiterte Analysen",
                "Zugang zur Forschungsplattform",
                "Monatliche Lernsession und Zugang zu Video-Demos",
                "Vor-Ort-Support alle 6 Monate"
            ]
        },
        expert: {
            title: "Experte",
            details: "Ein Plan, der Ihren Studierenden unbegrenzte Übungsfälle ermöglicht und Ihnen die Kontrolle über deren Lernfortschritt gibt",
            features: [
                "Alles davon plus",
                "Forschungsdaten, extrahiert vom Clinical-Metrics-Team mit zusammenfassenden Statistiken und Analysen",
                "Wöchentliche Lernsession",
                "Vor-Ort-Support alle 3 Monate"
            ]
        }
    },
    testimonialsTitle: "Sieh, was andere sagen",
    bookDemoTextForTestimonials: "Buchen Sie noch heute Ihre Demo",
    testimonials: [
        "Wählen Sie einen erschwinglichen Plan, der mit den besten Funktionen ausgestattet ist – egal, ob Sie ein Medizinstudent sind, der sich verbessern möchte, ein Assistenzarzt, der für seine Prüfungen lernt, oder eine medizinische Fakultät, die interaktive Werkzeuge in ihren Lehrplan integrieren möchte.",
        "Ein Plan, der es Ihnen ermöglicht, unbegrenzt Übungsfälle in Ihrem eigenen Tempo zu absolvieren und Ihr Lernen individuell auf Ihre Ziele abzustimmen.",
        "Ein Plan, der es Ihren Studenten ermöglicht, unbegrenzt Übungsfälle zu bearbeiten, während Sie die Kontrolle behalten, um ihr Lernen zu steuern"
    ],
    aboutCard: {
        title: "CLINICAL METRICS ist ein Produkt von Clinical Metrics",
        detail: "Caroline Morton (Allgemeinmedizinerin und Epidemiologin, die zur Softwareentwicklerin wurde), Maxwell Flitton (Notaufnahme-Pfleger, der über die Physik zum Softwareentwickler wurde) und Toby Raupach (Facharzt für Kardiologie und Leiter der medizinischen Ausbildung) haben Clinical Metrics als Antwort auf unzureichendes medizinisches Simulationstraining aus ihrer Erfahrung heraus entwickelt."
    },
    whoIsThisFor: {
        title: "Wer ist das für?",
        detail: "Egal, ob Sie eine medizinische Fakultät, ein Dekanat oder einen Bildungsleiter im Krankenhaus sind - wir haben die richtige Lösung für Sie. Clinical Metrics hilft Ihren Studenten und Assistenzärzten, sicher zu üben und schneller Fortschritte zu machen, mit Preisen, die für Bildungseinrichtungen konzipiert sind."
    },
    whyVital: {
        title: "Warum ist das wichtig?",
        detail: "Die medizinische Ausbildung hat sich in den letzten 50 Jahren nicht verändert. Die Studenten lernen immer noch mit veralteten Werkzeugen, die nicht für die heutige Zeit geeignet sind. Wir haben das Gefühl, dass es an der Zeit ist, dies zu ändern. Simulationstraining ist der Goldstandard für die medizinische Ausbildung und wir glauben, dass es für alle zugänglich sein sollte."
    },
    whoWeAre: {
        title: "Wer wir sind",
        detail: "Wir sind ein Team von Ärzten und Krankenschwestern, die dort waren. Wir wissen, wie es ist, Medizin mit veralteten Werkzeugen zu lernen - denn wir haben es gelebt. Clinical Metrics wurde von Caroline Morton (Allgemeinmedizinerin und Epidemiologin, die zur Softwareentwicklerin wurde), Maxwell Flitton (Notaufnahme-Pfleger mit einem Hintergrund in Physik) und Toby Raupach (Facharzt für Kardiologie und Leiter der medizinischen Ausbildung) gegründet. Wir haben die Prüfungen abgelegt, die Studenten unterrichtet und auf den Stationen gearbeitet. Jetzt bauen wir die Werkzeuge, die wir uns gewünscht hätten."
    },
    deal:"Sommerangebot",
    yearlyPlan:"£199.99/Benutzer/Jahr (sparen Sie 2 Monate)"

};